export default __webpack_public_path__ + "static/media/hero-level-2-chars-mob.4ce3f93d.webp";